import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { OmuniState } from "../interfaces/omuni";

const initialState: OmuniState = {
    taskId: null,
    fetchingTask: "unknown",
    fetchingComment: "unknown",
    error: "",
}; 

const omuniSlice = createSlice({
    name: "omuni",
    initialState,
    reducers: {
        createTaskRequest: (state) => {
            state.fetchingTask = "loading";
            state.error = "";
        },
        createTaskSuccess: (state, action: PayloadAction<string>) => {
            state.fetchingTask = "success";
            state.taskId = action.payload;
        },
        createTaskFailure: (state, action: PayloadAction<string>) => {
            state.fetchingTask = "failure";
            state.error = action.payload;
        },
        addCommentRequest: (state) => {
            state.fetchingComment = "loading";
            state.error = "";
        },
        addCommentSuccess: (state) => {
            state.fetchingComment = "success";
        },
        addCommentFailure: (state, action: PayloadAction<string>) => {
            state.fetchingComment = "failure";
            state.error = action.payload;
        },
        resetOmuni: () => initialState,
    },
});

export const {
    createTaskRequest,
    createTaskSuccess,
    createTaskFailure,
    addCommentRequest,
    addCommentSuccess,
    addCommentFailure,
    resetOmuni,
} = omuniSlice.actions;

export default omuniSlice.reducer;
